"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressInput = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var window_scroll_1 = __importDefault(require("@react-hook/window-scroll"));
var fuse_js_1 = __importDefault(require("fuse.js"));
var lodash_noop_1 = __importDefault(require("lodash.noop"));
var react_1 = __importStar(require("react"));
var use_create_address_1 = require("../../hooks/use-create-address");
var use_keyboard_1 = require("../../hooks/use-keyboard");
var use_saved_addresses_by_account_1 = require("../../hooks/use-saved-addresses-by-account");
var use_smartystreets_1 = require("../../hooks/use-smartystreets");
var format_street_address_1 = require("../../lib/format-street-address");
var create_address_modal_1 = require("../create-address-modal");
var lookup_address_1 = require("../lookup-address");
var shared_styled_components_1 = require("../shared-styled-components");
var suggested_address_1 = require("../suggested-address");
function AddressInput(_a) {
    var _this = this;
    var accountUuid = _a.accountUuid, disabled = _a.disabled, onChange = _a.onChange, selectedAddress = _a.selectedAddress, _b = _a.width, width = _b === void 0 ? 400 : _b;
    var _c = use_smartystreets_1.useSmartyStreets(), lookupAddress = _c[0], lookupLoading = _c[1];
    var _d = react_1.useState(undefined), addressQuery = _d[0], setAddressQuery = _d[1];
    var _e = react_1.useState(undefined), lookupResults = _e[0], setLookupResults = _e[1];
    var _f = react_1.useState('below'), popoverLocation = _f[0], setPopoverLocation = _f[1];
    var _g = react_1.useState(false), isCustomAddressModalOpen = _g[0], setIsCustomAddressModalOpen = _g[1];
    // get the window scroll position
    var scrollY = window_scroll_1.default(60);
    var triggerRef = react_1.useRef(null);
    var inputRef = react_1.useRef(null);
    var _h = core_ui_1.usePopover(), isPopoverOpen = _h.isPopoverOpen, closePopover = _h.closePopover, openPopover = _h.openPopover, popoverRef = _h.popoverRef, targetRef = _h.targetRef;
    var createAddress = use_create_address_1.useCreateAddress();
    var onKeyDown = use_keyboard_1.useKeyboardControls({
        inputRef: inputRef,
        popoverRef: popoverRef,
        onEsc: function (e) { return handleReset(); },
    }).onKeyDown;
    /**
     * immediately fetch previously saved addresses
     */
    var _j = use_saved_addresses_by_account_1.useSavedAddressesByAccount(accountUuid), previouslySavedAddresses = _j.data, revalidate = _j.revalidate;
    /** open popover */
    function handleOpenPopover() {
        if (!isPopoverOpen)
            openPopover();
    }
    /** reset the component */
    function handleReset() {
        setLookupResults(undefined);
        closePopover();
        setAddressQuery(undefined);
    }
    /**
     * On click outside of the trigger address field
     * - reset the address query to undefined
     * - check if the element clicked was the address-lookup, if so, return and NOT close popover
     * - otherwise close popover and reset setAddressQuery
     */
    core_ui_1.useOnClickOutside(triggerRef, function (event) {
        if (!event.target)
            return;
        var _a = event.target, name = _a.name, id = _a.id;
        // if clicking on search field, return
        if (name === 'address-lookup')
            return;
        // if clicking on 'add custom address', open modal
        if (id === 'open-add-address-modal') {
            setIsCustomAddressModalOpen(true);
        }
        // close the popover
        closePopover();
    });
    /**
     * on select of a smarty streets suggestion
     * - trigger onChange
     * - save address
     * - close popover
     * - reset setAddressQuery
     * - reset existing results
     */
    var handleSuggestionSelect = function (addressSuggestion) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    closePopover();
                    setAddressQuery(undefined);
                    return [4 /*yield*/, createAddress({
                            accountUuid: accountUuid,
                            address: addressSuggestion,
                        })];
                case 1:
                    response = _a.sent();
                    if (response === null || response === void 0 ? void 0 : response.data) {
                        onChange(response.data);
                    }
                    return [4 /*yield*/, revalidate()];
                case 2:
                    _a.sent();
                    if (lookupResults)
                        setLookupResults(undefined);
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * on select of a saved address result
     * - trigger onChange
     * - close popover
     * - reset setAddressQuery
     * - reset existing results
     */
    var handleSavedAddressSelect = function (resultSelectedAddress) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            closePopover();
            setAddressQuery(undefined);
            onChange(resultSelectedAddress);
            if (lookupResults)
                setLookupResults(undefined);
            return [2 /*return*/];
        });
    }); };
    /**
     * Fuzzy search for previously saved addresses.
     * Initialize Fuse and Determine what fields to search against.
     * Memoize filteredSavedAddresses and return filtered results
     */
    var fuseFilterSavedAddresses = new fuse_js_1.default(previouslySavedAddresses || [], {
        keys: ['addressLine1', 'addressLine2', 'city', 'stateOrArea', 'postalCode'],
    });
    var filteredSavedAddresses = react_1.useMemo(function () {
        if (addressQuery) {
            var filteredResults = fuseFilterSavedAddresses.search(addressQuery);
            return filteredResults.map(function (res) { return res.item; });
        }
    }, [addressQuery]);
    /**
     * If the popover is open, set focus to the address text field
     */
    react_1.useEffect(function () {
        var _a;
        if (isPopoverOpen)
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [isPopoverOpen]);
    var DEBOUNCE_SEARCH = 500;
    /**
     * On input, debounce lookup
     * if empty (e.g. fieldValue === "") - reset the component
     */
    var searchFetch = react_1.useCallback(function (value) {
        function fetchData(lookupAddressQuery) {
            return __awaiter(this, void 0, void 0, function () {
                var results;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, lookupAddress(lookupAddressQuery, 5)];
                        case 1:
                            results = _a.sent();
                            setLookupResults(results);
                            return [2 /*return*/];
                    }
                });
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        if (value)
            fetchData(value);
    }, [lookupAddress, setLookupResults]);
    var debouncedSearchFetch = core_ui_1.useDebouncedCallback(searchFetch, DEBOUNCE_SEARCH);
    /**
     *  Set the popover location based on scroll position
     */
    react_1.useEffect(function () {
        var _a;
        if (!targetRef)
            return;
        if (scrollY > 560 || (targetRef.current && ((_a = targetRef.current) === null || _a === void 0 ? void 0 : _a.offsetTop) < 560)) {
            // 560px is the height of the popover with 5 suggested and 5 lookup results (10)
            setPopoverLocation('below');
            return;
        }
        setPopoverLocation('above');
    }, [scrollY, targetRef]);
    /**
     * renderPreviouslySavedAddresses
     * render previously saves addresses, or FILTERED previously saves addresses
     */
    function renderPreviouslySavedAddresses(savedAddresses, query) {
        if (savedAddresses.length === 0)
            return;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_ui_1.Padding, { x: 16, y: 8 },
                react_1.default.createElement(core_ui_1.Text, { size: "small", weight: 600, color: core_ui_1.colors.steel[300] }, "Suggestions")),
            react_1.default.createElement("div", { className: "previously-saved-addresses" }, savedAddresses === null || savedAddresses === void 0 ? void 0 : savedAddresses.slice(0, 5).map(function (savedAddress) { return (react_1.default.createElement(suggested_address_1.SuggestedAddress, { onKeyDown: onKeyDown, key: savedAddress.addressLine1 + "-" + savedAddress.addressLine2, address: savedAddress, handleSelectedResult: function (addr) { return handleSavedAddressSelect(addr); }, addressQuery: query })); }))));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(shared_styled_components_1.StyledAddressFieldWrapper, { style: { width: width }, ref: targetRef },
            react_1.default.createElement(shared_styled_components_1.StyledAddressField, { tabIndex: 0, role: "button", onKeyDown: lodash_noop_1.default, onClick: handleOpenPopover, ref: triggerRef, disabled: disabled },
                selectedAddress && (react_1.default.createElement(core_ui_1.Text, null,
                    react_1.default.createElement(shared_styled_components_1.StyledSelectedAddress, null, format_street_address_1.formatStreetAddress(selectedAddress)))),
                !selectedAddress && (react_1.default.createElement("div", null,
                    react_1.default.createElement(core_ui_1.Text, { color: core_ui_1.colors.steel[300] }, "No address selected"),
                    !isPopoverOpen && (react_1.default.createElement(shared_styled_components_1.StyledIconWrapper, null,
                        react_1.default.createElement(core_ui_1.IconSearch, { size: 12 })))))),
            selectedAddress && (react_1.default.createElement(shared_styled_components_1.StyledIconWrapper, { tabIndex: 0, role: "button", onKeyDown: lodash_noop_1.default, onClick: function () {
                    onChange(undefined);
                    handleReset();
                } },
                react_1.default.createElement(core_ui_1.IconCross, { size: 12 }))),
            react_1.default.createElement("div", { style: {
                    position: 'relative',
                } },
                react_1.default.createElement(shared_styled_components_1.StyledPopover, { ref: popoverRef, style: { width: width }, location: popoverLocation },
                    react_1.default.createElement(core_ui_1.PopoverAnimation, { isOpen: isPopoverOpen, direction: "down" },
                        react_1.default.createElement(core_ui_1.Box, { border: 1, borderRadius: 3, boxShadow: "card", backgroundColor: "white" },
                            react_1.default.createElement(shared_styled_components_1.StyledScrollableResults, null,
                                react_1.default.createElement(core_ui_1.Padding, { size: 16 },
                                    react_1.default.createElement(core_ui_1.Input, { "data-address-lookup": true, autoComplete: "off", className: "address-lookup", innerRef: inputRef, name: "address-lookup", type: "search", placeholder: "Search", onChange: function (inputValue) {
                                            setAddressQuery(inputValue);
                                            if (debouncedSearchFetch) {
                                                debouncedSearchFetch(inputValue);
                                            }
                                        }, onKeyDown: onKeyDown, disabled: disabled, value: addressQuery })),
                                !addressQuery &&
                                    previouslySavedAddresses &&
                                    renderPreviouslySavedAddresses(previouslySavedAddresses.slice(0, 5)),
                                addressQuery &&
                                    filteredSavedAddresses &&
                                    renderPreviouslySavedAddresses(filteredSavedAddresses, addressQuery),
                                addressQuery && (react_1.default.createElement(core_ui_1.Padding, { x: 16, y: 8 },
                                    react_1.default.createElement(core_ui_1.Flexbox, { alignItems: "center", justifyContent: "space-between" },
                                        react_1.default.createElement(core_ui_1.Text, { size: "small", weight: 600, color: core_ui_1.colors.steel[300] },
                                            "Search for",
                                            ' ',
                                            react_1.default.createElement(core_ui_1.Text, { display: "inline", weight: 700 }, addressQuery)),
                                        lookupLoading && react_1.default.createElement(core_ui_1.CircleSpinnerInline, null)))),
                                addressQuery && addressQuery !== '' && lookupResults && (lookupResults === null || lookupResults === void 0 ? void 0 : lookupResults.result.length) > 0 && (react_1.default.createElement(shared_styled_components_1.StyledResultsWrapper, { className: "lookup-results" },
                                    lookupLoading && react_1.default.createElement(shared_styled_components_1.StyledDisabledResults, null),
                                    lookupResults.result.map(function (suggestion) { return (react_1.default.createElement(lookup_address_1.LookupAddress, { key: suggestion.streetLine + "-" + suggestion.secondary, suggestion: suggestion, handleSelectedResult: handleSuggestionSelect, addressQuery: addressQuery, onKeyDown: onKeyDown })); }))),
                                react_1.default.createElement(core_ui_1.Padding, { size: 12 },
                                    react_1.default.createElement(shared_styled_components_1.StyledCreateAddressButton, { id: "open-add-address-modal" },
                                        react_1.default.createElement(core_ui_1.IconPlus, { color: "#262D46" }),
                                        react_1.default.createElement(core_ui_1.Spacing, { width: 4 }),
                                        "Add custom address")))))))),
        react_1.default.createElement(create_address_modal_1.CreateAddressModal, { accountUuid: accountUuid, isOpen: isCustomAddressModalOpen, toggle: setIsCustomAddressModalOpen, onSubmit: onChange })));
}
exports.AddressInput = AddressInput;
